module.exports = __webpack_public_path__ + "media/images/badge/fan-sfegatato_secondary-15713daa2e61e2cd015e99d58e7142bb.png";